import { getMeta } from '../utils/notification-helpers';
import NotificationIcon from '../NotificationIcon';
import InvestIcon from '../../../../assets/plant-icon.svg';

const InvestmentNotification = ({ notification }) => {
  const meta = getMeta(notification);

  return (
    <div className="flex items-start gap-2">
      <NotificationIcon avatarSrc={meta.avatar} subIcon={InvestIcon} />
      <div className="ml-2 min-w-0 w-[85%]">
        <p className="text-sm text-growth-green-900">
          <span className="font-bold">
            {meta.firstName} {meta.lastName}
          </span>
          <span> invested </span>
          <span className="font-bold text-growth-green">{meta.pointInvested} Twigs</span>
          <span> in your </span>
          <span className="font-bold text-growth-green">article</span>
        </p>

        {meta.articleTitle && (
          <p className="text-sm font-bold text-growth-green-900 mt-1">
            &ldquo;{meta.articleTitle}&rdquo;
          </p>
        )}
      </div>
    </div>
  );
};

export default InvestmentNotification;
